module.exports = __webpack_public_path__ + "img/the-cheerleader.41567f13.svg";